import React, { useCallback, useMemo, useState } from 'react';
import { Map as GoogleMap, MapEvent } from '@vis.gl/react-google-maps';
import useScreenSize from '../../../hooks/useScreenSize';
import { getLocationPickerMapOptions } from '../../../utils/helpers/map';
import { MapContainer, Pin, ShadowDot } from './styled';
import { MapReuseReset } from '../MapReuseReset';
import { MapOptionsSync } from '../MapOptionsSync';

const PICKER_MAP_ZOOM = 14;

interface LocationPickerMapProps {
  center: google.maps.LatLngLiteral;
  onCenterChange?: (center: google.maps.LatLngLiteral) => void;
  isPreview?: boolean;
}

export const LocationPickerMap: React.FC<LocationPickerMapProps> = ({
  center,
  onCenterChange,
  isPreview = false
}) => {
  const { isSmall } = useScreenSize();
  const [isDragging, setIsDragging] = useState(false);

  const mapOptions = useMemo(
    () => getLocationPickerMapOptions(isSmall, isPreview),
    [isSmall, isPreview]
  );

  const handleDragStart = useCallback(() => setIsDragging(true), []);

  const handleDragEnd = useCallback(
    ({ map }: MapEvent) => {
      setIsDragging(false);
      const mapCenter = map.getCenter();
      if (mapCenter) {
        onCenterChange?.({ lat: mapCenter.lat(), lng: mapCenter.lng() });
      }
    },
    [onCenterChange]
  );

  return (
    <MapContainer $height="100%">
      <GoogleMap
        reuseMaps
        defaultCenter={center}
        defaultZoom={PICKER_MAP_ZOOM}
        onDragstart={handleDragStart}
        onDragend={handleDragEnd}
        {...mapOptions}
      >
        <MapReuseReset />
        <MapOptionsSync options={mapOptions} />
      </GoogleMap>

      <ShadowDot $dragging={isDragging} />
      <Pin $dragging={isDragging}>
        <img src="/static/images/new_ad/icons/icon-map-pin.png" alt="pin" />
      </Pin>
    </MapContainer>
  );
};
